import React, {useMemo, Fragment} from 'react';
import {connect} from "react-redux";

import {FormattedMessage} from "react-intl";
import {Button} from "@mui/material";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import AddIcon from "@mui/icons-material/Add";
import ConfirmButtons from "./ConfirmButtons";
import {CABINET_FILTER_NAMES, FEATURE_PICKER_TYPE, SQFT_FEATURES} from "../../../../constants";
import {setFeaturePicker} from "../../../../../../actions/sqftMenuFunctions";
import workspaceControllers from "../../../canvas/store/workspaceControllers";
import FeatureName from "../../../../../visComponents/featureName";
import {getCurrentLayout} from "../../../../../appLayout";
import FeatureThumbnail from "../../../../../visComponents/featureThumbnail";
import workspace from "../../../canvas/core/workspace";

const Hinges = (props) => {
  const {featurePicker, setFeaturePicker, selectedFeatureInPicker, sqftActiveShapeId, resourceControllerCounter} = props;
  const layout = getCurrentLayout();

  const openHingePicker = (isAdding) => {
    setFeaturePicker(
      {
        isOpen: true,
        modelId: null,
        partIds: [SQFT_FEATURES.hinge],
        shapeId: sqftActiveShapeId,
        type: FEATURE_PICKER_TYPE.hinges,
        isAdding: isAdding
      }
    )
  }

  const confirmCallback = () => {
    if (featurePicker.isAdding) {
      const shape = workspace.getShapeById(sqftActiveShapeId);
      const selectedHinge = layout.getFeatureById(selectedFeatureInPicker, true);
      shape.shapeCabinet.generateAttachedFeatures(CABINET_FILTER_NAMES.hinges,{ hinges: selectedHinge });
      workspaceControllers.hinge.updateReduxCounterOnChange();
    } else {
      workspaceControllers.hinge.changeFeatureForTheShape(featurePicker.shapeId, selectedFeatureInPicker);
    }

    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '', isAdding: false });
  }

  const cancelCallback = () => {
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '', isAdding: false });
  }

  const lineHingesModel = useMemo(() => {
    return workspaceControllers.hinge.getAllResourcesForTheShape(sqftActiveShapeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceControllerCounter]);

  const hasHinges = lineHingesModel.length > 0;
  const feature = hasHinges && layout.getFeatureById(lineHingesModel[0].featureId, true);

  return (
    <div className="sr__section sr__handles">
      <div className="sr__section-title">
        <FormattedMessage id="Current Hinge"/>
      </div>
      <div>
        {hasHinges && (
          <Fragment>
            <div className="sr__section-image">
              <FeatureThumbnail feature={feature} dbFeatureId={feature.dbFeature.id}/>
            </div>
            <label className="handles__label">
              <FeatureName feature={feature} />
            </label>
          </Fragment>
        )}
        {
          featurePicker.isOpen && featurePicker.type === FEATURE_PICKER_TYPE.hinges
            ? <ConfirmButtons confirmCallback={confirmCallback} cancelCallback={cancelCallback}/>
            : (
              <Button
                className={"sr__button "}
                variant="outlined"
                color="primary"
                startIcon={hasHinges ? <ShuffleIcon style={{ transform: 'rotate(180deg)' }}/> : <AddIcon />}
                onClick={() => openHingePicker(!hasHinges)}
              >
                <FormattedMessage id={hasHinges ? "Swap Hinge" : "Add Hinge"}/>
              </Button>
            )
        }
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
  featurePicker: store.sqftMenuState.featurePicker,
  selectedFeatureInPicker: store.sqftMenuState.selectedFeatureInPicker,
  resourceControllerCounter: store.sqftResourceState.resourceControllerCounter,
});

const mapDispatchToProps = {
  setFeaturePicker
};

export default connect(mapStateToProps, mapDispatchToProps)(Hinges);
